var types_TSegmentationDataTypeEnum = /*#__PURE__*/ function(TSegmentationDataTypeEnum) {
    TSegmentationDataTypeEnum["Area"] = "AREA";
    TSegmentationDataTypeEnum["CompanyEntry"] = "COMPANY_ENTRY";
    TSegmentationDataTypeEnum["Country"] = "COUNTRY";
    TSegmentationDataTypeEnum["CustomField"] = "CUSTOM_FIELD";
    TSegmentationDataTypeEnum["Gender"] = "GENDER";
    TSegmentationDataTypeEnum["Headquarter"] = "HEADQUARTER";
    TSegmentationDataTypeEnum["Position"] = "POSITION";
    TSegmentationDataTypeEnum["PositionCategory"] = "POSITION_CATEGORY";
    return TSegmentationDataTypeEnum;
}({});
var types_TCustomFieldTypeEnum = /*#__PURE__*/ function(TCustomFieldTypeEnum) {
    TCustomFieldTypeEnum["Date"] = "DATE";
    TCustomFieldTypeEnum["Multiple"] = "MULTIPLE";
    TCustomFieldTypeEnum["Number"] = "NUMBER";
    TCustomFieldTypeEnum["Text"] = "TEXT";
    return TCustomFieldTypeEnum;
}({});
export { types_TCustomFieldTypeEnum as TCustomFieldTypeEnum, types_TSegmentationDataTypeEnum as TSegmentationDataTypeEnum };
